<template>
  <div>
    <thumbnail-header
      class="clearfix"
      :imagen="usuario.foto_url"
      :titulo="fullname(usuario)"
      :subtitulo="$I18n.t('guardia')"
      tamano="md"
    >
      <template #subtitulo>
        <div v-if="guardia.tipo === 'extraordinaria'" class="label label-info">
          {{ $I18n.t('Extraordinaria') }}
        </div>
        <div v-else class="label label-default">
          {{ $I18n.t('ordinaria') }}
        </div>
        <div v-if="guardia.causa === 'personal'" class="label label-info m-l-xs">
          {{ $I18n.t('personal') }}
        </div>
        <div v-else class="label label-default m-l-xs">
          {{ $I18n.t('lectiva') }}
        </div>
        <div v-if="guardia.asignacion_vista" class="label label-success m-l-lg">
          {{ $I18n.t('asignacion_vista') }}
        </div>
        <div v-else class="label label-warning m-l-lg">
          {{ $I18n.t('asignacion_no_vista') }}
        </div>
      </template>
    </thumbnail-header>
    <template v-if="guardia.lectiva">
      <div v-if="horario" class="m-t">
        <table class="table cifra-table text-center">
          <tbody>
            <tr>
              <td>
                <div class="label label-default">
                  {{ horario.hora_inicio }} - {{ horario.hora_fin }}
                </div>
              </td>
              <td>
                {{ horario.asignatura.nombre }}
              </td>
            </tr>
            <tr>
              <td>
                <strong v-if="horario.tipo === 'desdoble'">
                  {{ horario.asignatura.nombre_estructura }}
                </strong>
                <strong v-else>{{ horario.grupo.etiqueta }}</strong>
              </td>
              <td>
                {{ fullname(horario.profesor) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        {{ $I18n.t('sesion_horario_ya_no_existe') }}
      </div>
    </template>
    <template v-else>
      <div v-if="evento" class="m-t">
        <table class="table cifra-table text-center">
          <tbody>
            <tr>
              <td>
                <div class="label label-default">
                  {{ evento.hora_inicio }} - {{ evento.hora_fin }}
                </div>
              </td>
              <td>
                {{ evento.nombre }}
              </td>
            </tr>
            <tr>
              <td>
                <strong>{{ evento.grupo.etiqueta }}</strong>
              </td>
              <td>
                {{ fullname(evento.usuario) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        {{ $I18n.t('sesion_horario_ya_no_existe') }}
      </div>
    </template>
    <div class="form-actions m-t-lg">
      <confirm-link
        v-if="!disabled"
        class="pull-left"
        @confirmado="eliminar"
      >
        <a class="btn btn-danger">
          <i class="fa fa-trash"></i> {{ $I18n.t('Eliminar') }}
        </a>
      </confirm-link>
      <button class="btn btn-default" @click.prevent="$emit('cancelado')">
        {{ $I18n.t('Cerrar') }}
      </button>
    </div>
  </div>
</template>

<script>
import { usuarios } from 'cifra-api-js';
import { showApiErrors } from '../../../libs/cifra/flash';
import guardias from '../../../api/cifra/guardias/guardias';
import Overlay from '../../../libs/cifra/overlay';

export default {
  props: {
    disabled: { type: Boolean, default: false },
    guardia: { type: Object, required: true },
  },
  emits: ['cancelado', 'eliminado'],
  data() {
    return {
    };
  },
  computed: {
    usuario() {
      return this.guardia.usuario;
    },
    horario() {
      return this.guardia.horario;
    },
    evento() {
      return this.guardia.evento;
    },
  },
  methods: {
    fullname: usuarios.fullname,
    eliminar() {
      if (this.disabled) return;

      const overlay = new Overlay(this.$el);
      overlay.show();
      guardias.destroy(this.guardia.id).then((result) => {
        overlay.hide();
        this.$toast.success(this.$I18n.t('registro_eliminado_correctamente'));
        this.$emit('eliminado', result);
      }).catch((result) => {
        overlay.hide();
        showApiErrors(result);
      });
    },
  },
};
</script>
